import * as yup from "yup";

export const yupPasswordValidator = yup
    .string()
    .required('You must enter a password')
    .min(8, 'Password must be at least 8 characters long')
    .test('password-complexity-number', 'You password must contain a number', val => /[0-9]+/.test(val))
    .test('password-complexity-upperchar', 'You password must contain an uppercase character', val => /[A-Z]+/.test(val))
    .test('password-complexity-lowerchar', 'You password must contain a lowercase character', val => /[a-z]+/.test(val))
    .test('password-complexity-symbol', 'You password must contain a symbol (!$-_)', val => /[!@#$%^&*()_+=\\[{\]};:<>|./?,-]/.test(val));